// extracted by mini-css-extract-plugin
module.exports = {"attribution":"blockquotes_attribution__2JpUc"};